import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {plainToClass, plainToClassFromExist} from 'class-transformer';
import {environment} from '../../../environments/environment';
import {EventParticipationRequestApiModel} from '../models/event-participation-request.api-model';
import {QueryParamsApiModel} from '../models/query-params-api.model';
import {ResultListApiModel} from '../models/result-list.api.model';
import {QueryParamsService} from '../../core/services/query-params.service';

@Injectable({
  providedIn: 'root'
})
export class EventParticipationRequestRestService {
  private readonly resource = '/event_participation_requests';

  constructor(
    private readonly http: HttpClient,
    private readonly params: QueryParamsService
  ) {}

  public getCollection(
    queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel()
  ): Observable<ResultListApiModel<EventParticipationRequestApiModel>> {
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<ResultListApiModel<EventParticipationRequestApiModel>>(`${environment.apiUrl}${this.resource}`, {params})
      .pipe(map((result) => plainToClassFromExist(new ResultListApiModel<EventParticipationRequestApiModel>(EventParticipationRequestApiModel), result as object)));
  }

  public approve(requestId: number): Observable<EventParticipationRequestApiModel> {
    return this.http.post<EventParticipationRequestApiModel>(`${environment.apiUrl}${this.resource}/${requestId}/approve`, {})
      .pipe(map((result) => plainToClass(EventParticipationRequestApiModel, result)));
  }

  public reject(requestId: number, reason?: string | null): Observable<EventParticipationRequestApiModel> {
    return this.http.post<EventParticipationRequestApiModel>(`${environment.apiUrl}${this.resource}/${requestId}/reject`, {
      reason: reason || null
    }).pipe(map((result) => plainToClass(EventParticipationRequestApiModel, result)));
  }
}

